import { Component } from ".././base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

// Declare Coveo types
declare global {
    interface Window {
        Coveo: {
            $: JQueryStatic;
            state: (element: HTMLElement, key: string, value?: any) => any;
            QueryEvents: {
                executeQuery: string;
            };
        };
    }
}

export class SearchHistory extends Component {
    private static readonly HISTORY_KEY = 'coveo_search_history';
    private static readonly MAX_HISTORY_ITEMS = 10;

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
    }

    public async init(): Promise<void> {
        this.renderHistory();
        this.bindEvents();
    }

    private renderHistory(): void {
        const history = this.getSearchHistory();
        if (!history.length) {
            this._element.innerHTML = '<div class="coveo-search-history-empty">No recent searches</div>';
            return;
        }

        const historyList = document.createElement('ul');
        historyList.className = 'coveo-search-history-list';

        history.forEach(item => {
            const listItem = document.createElement('li');
            listItem.className = 'coveo-search-history-item';

            const link = document.createElement('a');
            link.href = '#';
            link.textContent = item;
            link.addEventListener('click', (e) => {
                e.preventDefault();
                this.executeSearch(item);
            });

            const removeButton = document.createElement('button');
            removeButton.className = 'coveo-search-history-remove';
            removeButton.innerHTML = '×';
            removeButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.removeFromHistory(item);
            });

            listItem.appendChild(link);
            listItem.appendChild(removeButton);
            historyList.appendChild(listItem);
        });

        this._element.innerHTML = '';
        this._element.appendChild(historyList);
    }

    private bindEvents(): void {
        // Listen for Coveo's querySuccess event
        if (window.Coveo) {
            window.Coveo.$(document).on('querySuccess', (e: any, args: any) => {
                if (args && args.query && args.query.q) {
                    this.addToHistory(args.query.q);
                }
            });
        }
    }

    private getSearchHistory(): string[] {
        try {
            const history = localStorage.getItem(SearchHistory.HISTORY_KEY);
            return history ? JSON.parse(history) : [];
        } catch {
            return [];
        }
    }

    private addToHistory(query: string): void {
        const history = this.getSearchHistory();
        // Remove if already exists
        const index = history.indexOf(query);
        if (index > -1) {
            history.splice(index, 1);
        }
        // Add to beginning
        history.unshift(query);
        // Keep only the most recent items
        if (history.length > SearchHistory.MAX_HISTORY_ITEMS) {
            history.pop();
        }
        localStorage.setItem(SearchHistory.HISTORY_KEY, JSON.stringify(history));
        this.renderHistory();
    }

    private removeFromHistory(query: string): void {
        const history = this.getSearchHistory();
        const index = history.indexOf(query);
        if (index > -1) {
            history.splice(index, 1);
            localStorage.setItem(SearchHistory.HISTORY_KEY, JSON.stringify(history));
            this.renderHistory();
        }
    }

    private executeSearch(query: string): void {
        // Use Coveo's state to set the query
        if (window.Coveo) {
            const searchbox = window.Coveo.$(document).find('.CoveoSearchbox')[0];
            if (searchbox) {
                window.Coveo.state(searchbox, 'q', query);
                // Trigger the search
                window.Coveo.$(document).trigger(window.Coveo.QueryEvents.executeQuery);
            }
        }
    }
}

ComponentFactory.registerComponent("SearchHistory", SearchHistory);
